<template>
	<form class="form-overlay" @submit.prevent="generateContract">
		<i @click="hideFormOverlay" class="form-overlay__close" />
		<legend class="form-overlay__legend">
			Wprowadź dane swojej firmy,<br />
			żeby wygenerować umowę
		</legend>

		<label class="form-overlay__label" for="companyName">Nazwa firmy</label>
		<input
			id="companyName"
			type="text"
			required
			v-model="companyName"
			:disabled="status === 'pending'"
			class="topbar__input form-overlay__input"
		/>
		<label class="form-overlay__label" for="address">Adres</label>
		<input
			id="address"
			type="text"
			required
			v-model="address"
			:disabled="status === 'pending'"
			class="topbar__input form-overlay__input"
		/>
		<label class="form-overlay__label" for="nip">NIP</label>
		<input
			id="nip"
			type="text"
			required
			pattern="[0-9]{10}"
			v-model="nip"
			:disabled="status === 'pending'"
			class="topbar__input form-overlay__input"
		/>

		<div class="form-overlay__button">
			<button type="submit" :disabled="status === 'pending'" class="button">
				Wygeneruj umowę
			</button>
		</div>

		<div v-if="status === 'pending'">Generowanie...</div>
		<div v-if="status === 'success'" class="success">Umowa wygenerowana pomyślnie!</div>
		<div v-if="status === 'error'" class="error">{{ error }}</div>
	</form>
</template>

<script>
import {formatPrice} from '../../common/helpers/format-price';
import {api} from '../core/services/api';
import FileDownloadMixin from '../mixins/file-download';

export default {
	name: 'GenerateContract',
	mixins: [FileDownloadMixin],
	data() {
		return {
			// possible statuses: editing, pending, success, error
			status: 'editing',
			companyName: null,
			address: null,
			nip: null,
			error: null,
		};
	},
	methods: {
		async generateContract(event) {
			this.status = 'pending';

			const {unitConfigurationId} = this.$route.query;

			try {
				if (unitConfigurationId) {
					await this.generateContractById(unitConfigurationId);
				} else {
					await this.generateContractFromPayload();
				}
				this.status = 'success';
			} catch (e) {
				this.status = 'error';
				this.error = 'Wystąpił nieoczekiwany błąd przy próbie generowania umowy.';
			}
		},
		async generateContractById(unitConfigurationId) {
			const response = await api.post(
				'/generateContractById',
				{
					unitConfigurationId,
					companyName: this.companyName,
					nip: this.nip,
					address: this.address,
				},
				{responseType: 'blob'}
			);
			this.forceFileDownload(response);
		},
		async generateContractFromPayload() {
			const unit = this.$store.getters['unitConfiguration/data']('unit');
			const baseUnit = [
				unit.fullName,
				formatPrice(this.$store.getters['unitConfiguration/baseCost']),
			];

			const components = this.$store.getters['unitConfiguration/extras'].map(component => [
				component[0],
				formatPrice(component[1]),
			]);

			const price = this.$store.getters['unitConfiguration/totalCostWithDiscountIncluded'];
			const unitConfigurationDump = this.$store.state.unitConfiguration;

			const response = await api.post(
				'/generateContractFromPayload',
				{
					baseUnit,
					components,
					price,
					unitConfigurationDump,
					companyName: this.companyName,
					nip: this.nip,
					address: this.address,
				},
				{responseType: 'blob'}
			);
			this.forceFileDownload(response);
		},
		hideFormOverlay() {
			this.companyName = null;
			this.nip = null;
			this.address = null;

			this.$store.commit('M_SET_APP_STATE', {
				isContractFormOverlayVisible: false,
			});
		},
	},
};
</script>
